const NotFound = () => {
  return (
    <>
      <div className="backgroundColor">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-4 backgroundColor shadow"
              style={{ position: "relative" }}
            >
              <h2 className="my-4 me-4 Pop-SemiBold text-light">
                MOHON MAAF HALAMAN KOSONG
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
